import { Stack, Text, Tooltip } from '@chakra-ui/react';
import { Show } from '@pelicargo/ui';
import { Link } from 'react-router-dom';

type Props = {
  label: string;
  value: string | null | undefined;
  to?: string;
  /** Set when the apply wrote this column onto the quote. */
  isFilled?: boolean;
};

export const Field = ({ label, value, to, isFilled = false }: Props) => {
  const labelColor = isFilled ? 'orange.500' : 'gray.500';
  const labelWeight = isFilled ? 'semibold' : undefined;

  const showNotMatched = !value;
  const showLink = !!value && !!to;
  const showPlain = !!value && !to;

  return (
    <Stack spacing="0.5">
      <Tooltip label="Written onto the quote by this apply" isDisabled={!isFilled}>
        <Text
          fontSize="xs"
          color={labelColor}
          fontWeight={labelWeight}
          textTransform="uppercase"
          letterSpacing="wide"
          w="fit-content"
        >
          {label}
        </Text>
      </Tooltip>

      <Show if={showNotMatched}>
        <Text fontSize="sm" color="gray.400" fontStyle="italic">
          Not matched
        </Text>
      </Show>

      <Show if={showLink}>
        <Link to={to ?? ''}>
          <Text fontSize="sm" fontWeight="bold" textDecoration="underline">
            {value}
          </Text>
        </Link>
      </Show>

      <Show if={showPlain}>
        <Text fontSize="sm" fontWeight="medium">
          {value}
        </Text>
      </Show>
    </Stack>
  );
};
